import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { usePageMeta } from "../hooks/useDocumentTitle";

export default function Datenschutz() {
    usePageMeta({
        title: "Datenschutz · Alexander Efremidis",
        description:
            "Datenschutzerklärung der Website von Alexander Efremidis — Informationen zu Datenerhebung, Cookies, Server-Logfiles und Ihren Rechten.",
        path: "/datenschutz",
    });

    return (
        <>
            <main className="legal">
                <Link to="/" className="back">
                    &larr; Zurück
                </Link>
                <h1>Datenschutzerklärung</h1>

                <section>
                    <h2>Datenschutz</h2>
                    <p>
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
                        Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen
                        Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                    </p>
                    <p>
                        Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit
                        auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen)
                        erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden
                        ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
                    </p>
                    <p>
                        Wir weisen darauf hin, dass die Datenübertragung im Internet (z.&nbsp;B. bei der Kommunikation
                        per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff
                        durch Dritte ist nicht möglich.
                    </p>
                </section>

                <section>
                    <h2>Cookies</h2>
                    <p>
                        Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner
                        keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot
                        nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf
                        Ihrem Rechner abgelegt werden und die Ihr Browser speichert.
                    </p>
                    <p>
                        Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies". Sie werden nach
                        Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert,
                        bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch
                        wiederzuerkennen.
                    </p>
                    <p>
                        Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden
                        und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder
                        generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers
                        aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website
                        eingeschränkt sein.
                    </p>
                </section>

                <section>
                    <h2>Server-LogFiles</h2>
                    <p>
                        Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
                        Server-Log Files, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                    </p>
                    <ul>
                        <li>Browsertyp und Browserversion</li>
                        <li>verwendetes Betriebssystem</li>
                        <li>Referrer URL</li>
                        <li>Hostname des zugreifenden Rechners</li>
                        <li>Uhrzeit der Serveranfrage</li>
                    </ul>
                    <p>
                        Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit
                        anderen Datenquellen wird nicht vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu
                        prüfen, wenn uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.
                    </p>
                </section>

                <section>
                    <h2>Kontaktformular</h2>
                    <p>
                        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
                        Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                        Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht
                        ohne Ihre Einwilligung weiter.
                    </p>
                </section>

                <section>
                    <h2>SSL-Verschlüsselung</h2>
                    <p>
                        Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher
                        Inhalte, wie zum Beispiel der Anfragen, die Sie an uns als Seitenbetreiber senden, eine
                        SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
                        Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                    </p>
                    <p>
                        Wenn die SSL-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht
                        von Dritten mitgelesen werden.
                    </p>
                </section>

                <section>
                    <h2>Recht auf Auskunft, Löschung, Sperrung</h2>
                    <p>
                        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
                        personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie
                        ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen
                        zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen
                        Adresse an uns wenden.
                    </p>
                </section>

                <section>
                    <h2>Widerspruch Werbe-Mails</h2>
                    <p>
                        Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung
                        von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit
                        widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle
                        der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.
                    </p>
                </section>
            </main>
            <Footer />
        </>
    );
}
